import { type BaseNotificationItemProps, NotificationItem } from '../components/NotificationItem'

export type SuspensionEndedProps = BaseNotificationItemProps & {
  type: 'suspension_ended'
  program: {
    id: string
    displayName: string
    color: string
    iconType?: string
  }
}

export function SuspensionEnded({ program, ...props }: SuspensionEndedProps) {
  return (
    <NotificationItem
      {...props}
      title={`${program.displayName} Suspension Ended`}
      descriptionAddon={
        <p className='flex text-sm text-gray-500'>{`Your suspension from ${program.displayName} has ended. You can work on this program again.`}</p>
      }
    />
  )
}
